import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

type AuthExternalState = Record<string, never>;

const initialState: AuthExternalState = {};

export const authExternalSlice = createSlice({
  name: 'auth_external',
  initialState,
  reducers: {
    appInstanceCreated: () => {},
    appInstanceError: (_state, _action: PayloadAction<string[]>) => {},
    appAuthDone: () => {},
  },
});

export const { appInstanceCreated, appInstanceError, appAuthDone } =
  authExternalSlice.actions;
